/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

import { WidgetDateRange } from './widgetDateRange.zod'
import { WidgetFilterEntry } from './widgetFilterEntry.zod'

export const sessionReplayListWidgetConfigLimitDefault = 10
export const sessionReplayListWidgetConfigLimitMax = 25

export const sessionReplayListWidgetConfigOrderByDefault = `start_time`
export const sessionReplayListWidgetConfigOrderDirectionDefault = `DESC`

export const SessionReplayListWidgetConfig = /* @__PURE__ */ zod.object({
    dateRange: zod.union([WidgetDateRange, zod.null()]).optional(),
    filterTestAccounts: zod.union([zod.boolean(), zod.null()]).optional(),
    widgetFilters: zod.union([zod.record(zod.string(), WidgetFilterEntry), zod.null()]).optional(),
    limit: zod
        .number()
        .min(1)
        .max(sessionReplayListWidgetConfigLimitMax)
        .default(sessionReplayListWidgetConfigLimitDefault)
        .describe('Maximum number of recordings to return.'),
    orderBy: zod
        .enum(['start_time', 'activity_score', 'recording_duration', 'duration', 'click_count', 'console_error_count'])
        .default(sessionReplayListWidgetConfigOrderByDefault)
        .describe('Recording ranking column.'),
    orderDirection: zod
        .enum(['ASC', 'DESC'])
        .default(sessionReplayListWidgetConfigOrderDirectionDefault)
        .describe('Sort direction for orderBy.'),
    savedFilterId: zod
        .union([zod.string(), zod.null()])
        .optional()
        .describe(
            'short_id of a saved session replay filter to refine the recordings shown. When set, the saved filter owns the date range and property filters; only orderBy, orderDirection, and limit still apply. Combine with collectionId to filter within a collection.'
        ),
    collectionId: zod
        .union([zod.string(), zod.null()])
        .optional()
        .describe(
            'short_id of a session replay collection to scope the widget to its pinned recordings. Combine with savedFilterId or property filters to narrow within the collection; orderBy, orderDirection, and limit still apply.'
        ),
})

export type SessionReplayListWidgetConfig = zod.input<typeof SessionReplayListWidgetConfig>
export type SessionReplayListWidgetConfigOutput = zod.output<typeof SessionReplayListWidgetConfig>
